import { DamageType } from "../damageType";
import type { Direction } from "../direction";
import { SmokeEffect } from "../effects/smokeEffect";
import type { ParticleEmitter } from "../interfaces";
import { ParticleType } from "../particleType";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { ProjectileWithMaxRange } from "../projectileWithMaxRange";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

const MAX_RANGE = 4;

export class Shrapnel extends ProjectileWithMaxRange implements ParticleEmitter {
	static key = "Shrapnel";

	constructor(xy: XY, direction: Direction) {
		super(xy, direction);
	}

	getParticleType(): ParticleType {
		return ParticleType.BULLET_TRAIL;
	}

	getMaxRange(): number {
		return MAX_RANGE;
	}

	protected damageTarget(target: PhysicalThingWithHp): number {
		return target.applyDamage(DamageType.EXPLOSION, STD_BASE_HP, this);
	}

	onHit(_damageDealt: number): void {
		this.board!.addEffect(new SmokeEffect(this.xy));
		this.board!.removeAtEndOfTurn(this);
	}

	onReachingMaxRange(): void {
		this.board!.removeAtEndOfTurn(this);
	}

	static deserialize(data: any): Shrapnel {
		const shrapnel = new Shrapnel(deserializeXY(data.xy), data.direction as Direction);
		shrapnel.visualId = data.visualId;
		shrapnel.travelledDistance = data.travelledDistance;
		return shrapnel;
	}
}
